function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.465 283.465"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("path", {
  className: styles["st0"] || "st0",
  d: "M42.52 248.031l-7.087-77.952 77.953-21.26 77.953 21.26-7.087 77.952"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["st0"] || "st0",
  d: "M236.22 240.945c-23.621 0-23.621 11.339-47.243 11.339-23.622 0-23.622-11.339-47.245-11.339s-23.622 11.339-47.245 11.339c-23.621 0-23.621-11.339-47.243-11.339-10.837 0-16.702 2.386-22.158 4.969-6.436 3.048-12.302 6.369-25.087 6.369M240.94 0v283.465M283.465 42.52H70.866M170.079 155.903v-49.604H56.693v49.604"
}))));